module.exports = __webpack_public_path__ + "static/media/start.c3cd5914.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/start.svg
// module id = 258
// module chunks = 1